import { createTheme } from "@mui/material/styles";

const muiTheme = createTheme({
	palette: {
		primary: { main: "#1F5A70" },
		error: { main: "#FB7185" },
		success: { main: "#10B981" },
	},
	shape: { borderRadius: 11 },
	typography: { fontFamily: "Inter, system-ui, sans-serif" },
});

export default muiTheme;
